import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import NavBar from "./components/NavBar";
import Home from './routes/Home';
import MemberSearch from './components/MemberSearch';
import Receipts from './routes/Receipts';
import ReceiptsForMember from './routes/ReceiptsForMember';
import Register from './components/Register';
import MemberDetails from "./routes/MemberDetails";
import AddNewMember from "./routes/NewMember";
import AddNewReceipt from "./components/NewReceipt";
import AddNewDepositTicket from "./components/DepositTicketForm";
import ViewDepositTicket from "./components/DepositTicketView";
import DepositTicketEdit from "./components/DepositTicketEdit";
import DepositTicketsList from "./components/DepositTicketsList";
import ReceiptDetails from "./routes/ReceiptDetails";
import Settings from './routes/Settings';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Logout from './components/Logout';
import ProtectedRoute from './routes/ProtectedRoute';
import AdminRoute from './routes/AdminRoute';
import useAuth from './context/useAuth';
import UserManagement from './components/UserManagement';
import EditMember from './components/EditMember';
import DonationHistorySummary from './components/DonationHistorySummary';
import About from './routes/About';
import Footer from './components/Footer';
import MergeMembers from './components/MergeMembers';
import DonationReport from './components/DonationsListReport';
import MemberDonationReport from './components/MemberListReport';
import MemberDonationReportByYear from './components/DonationReportByYear';
import AuditRecordsUser from './components/AuditRecordsUser';
import AuditRecordsReceipt from './components/AuditRecordsReceipt';
import AuditRecordsMember from './components/AuditRecordsMember';
import AddUser from './components/AddUser';
import UserProfile from './components/UserProfile';
import ReferenceManagement from './components/ReferenceManagement';
import MemoManagement from './components/MemoManagement';
import CardPayments from './components/CardPayments';
import CardPaymentEmail from './components/CardPaymentEmail';




const Routes = () => {
  const { token } = useAuth();

  return (
    <main className="container p-2">
      <NavBar />
      <Switch>
        {/* Public Routes: Accessible to everyone */}
        <Route path="/login" component={Login} />
        <Route path="/logout" component={Logout} />
        <Route path="/about" component={About} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/register" component={Register} />

        {/* Admin Routes: Only accessible to admin role */}
        <AdminRoute path="/config" component={Settings} />
        <AdminRoute path="/merge-members" component={MergeMembers} />
        <AdminRoute path="/audit-user" component={AuditRecordsUser} />
        <AdminRoute path="/audit-receipt" component={AuditRecordsReceipt} />
        <AdminRoute path="/audit-member" component={AuditRecordsMember} />
        <AdminRoute path="/reference-maintenance" component={ReferenceManagement} />

        {/* Protected Routes: Accessible to authenticated users with specific roles, admin is always allowed -no need to specify admin*/}
        <ProtectedRoute path="/members" component={MemberSearch} exact allowedRoles={['viewer', 'ops']} />
        <ProtectedRoute path="/memberDetails/:memberId" component={MemberDetails} exact allowedRoles={['viewer', 'ops', 'member']} />
        <ProtectedRoute path="/receiptDetails/:receiptNum" component={ReceiptDetails} allowedRoles={['viewer', 'ops', 'member']} />
        <ProtectedRoute path="/receiptsForMember/:memberId" component={ReceiptsForMember} allowedRoles={['viewer', 'ops']} />
        <ProtectedRoute path="/donationHistory/:memberId" component={DonationHistorySummary} allowedRoles={['viewer', 'ops', 'member']} />
        <ProtectedRoute path="/receipts" component={Receipts} exact allowedRoles={['viewer', 'ops']} />
        <ProtectedRoute path="/cardPayments" component={CardPayments} exact allowedRoles={['ops']} />
        <ProtectedRoute path="/cardPaymentEmail/:id" component={CardPaymentEmail} exact allowedRoles={['ops']} />
        <ProtectedRoute path="/addNewMember" component={AddNewMember} exact allowedRoles={['ops']} />
        <ProtectedRoute path="/addNewDepositTicket" component={AddNewDepositTicket} exact allowedRoles={['ops']} />
        <ProtectedRoute path="/viewDepositTicket/:id" component={ViewDepositTicket} exact allowedRoles={['viewer', 'ops']} />
        <ProtectedRoute path="/editDepositTicket/:id" component={DepositTicketEdit} exact allowedRoles={['ops']} />
        <ProtectedRoute path="/depositTicketsList" component={DepositTicketsList} exact allowedRoles={['viewer', 'ops']} />
        <ProtectedRoute path="/addNewReceipt/:memberId" component={AddNewReceipt} exact allowedRoles={['ops']} />
        <ProtectedRoute path="/editMember/:memberId" component={EditMember} exact allowedRoles={['ops', 'member']} />
        <ProtectedRoute path="/donations" component={DonationReport} exact allowedRoles={['viewer', 'ops']} />
        <ProtectedRoute path="/memberDonations" component={MemberDonationReport} exact allowedRoles={['viewer', 'ops']} />
        <ProtectedRoute path="/memberDonationsbyYear" component={MemberDonationReportByYear} exact allowedRoles={['viewer', 'ops']} />
        <ProtectedRoute path="/user-management" component={UserManagement} exact allowedRoles={['ops']} />
        <ProtectedRoute path="/add-user" component={AddUser} exact allowedRoles={['ops']} />
        <ProtectedRoute path="/memo-management/:memberId" component={MemoManagement} exact allowedRoles={['ops']} />
        {/* Protected Route: Home page, accessible to authenticated users */}
        <ProtectedRoute path="/" component={Home} exact allowedRoles={['viewer', 'ops', 'member']} />
        <ProtectedRoute path="/reset-password" component={ResetPassword} exact allowedRoles={['viewer', 'ops', 'member']} />
        <ProtectedRoute path="/userProfile" component={UserProfile} exact allowedRoles={['viewer', 'ops', 'member']} />

        {/* Default redirect based on authentication state */}
        {token ? <Redirect to="/" /> : <Redirect to="/login" />}
      </Switch>
      <Footer />
    </main>
  );
};

export default Routes;